import * as yup from 'yup';
import svStrings from '../../../sv-strings';
import { FIELD_TYPES, Field, UIschema } from '../../../types';
import { StaffMember, StaffRole } from './api-types';
import countries from '../../../countries';

const roleOptions = Object.values(StaffRole);
const roleLabels = roleOptions.map((role) => svStrings.staffRoles[role]);

const sortedCountries = countries.sort((countryA, countryB) => {
  if (countryA.sv < countryB.sv) {
    return -1;
  }
  if (countryA.sv > countryB.sv) {
    return 1;
  }
  return 0;
});

const nationalityOptions = sortedCountries.map((country) => country.en);
const translatedNationalityOptions = sortedCountries.map((country) => country.sv);

export const getStaffMemberUiSchema = (member?: StaffMember): UIschema => ({
  name: 'Information',
  fields: [
    {
      title: svStrings.staff.givenName,
      id: 'member-given-name',
      type: FIELD_TYPES.TEXT,
      key: 'givenName',
      value: member?.givenName,
      validation: yup.string().required(svStrings.staff.givenNameRequired),
    },
    {
      title: svStrings.staff.surName,
      id: 'member-sur-name',
      type: FIELD_TYPES.TEXT,
      key: 'surName',
      value: member?.surName,
      validation: yup.string().required(svStrings.staff.surNameRequired),
    },
    {
      title: svStrings.staff.displayName,
      id: 'member-display-name',
      type: FIELD_TYPES.TEXT,
      key: 'displayName',
      value: member?.displayName,
    },
    {
      title: svStrings.staff.role,
      id: 'member-role',
      type: FIELD_TYPES.SELECT,
      key: 'role',
      options: roleOptions,
      optionsText: roleLabels,
      value: member?.role,
    },
    {
      title: svStrings.staff.roleDisplayName,
      id: 'member-role-display-name',
      type: FIELD_TYPES.TEXT,
      key: 'roleDisplayName',
      value: member?.roleDisplayName,
    },
    {
      title: svStrings.staff.birthDay,
      id: 'member-birth-day',
      type: FIELD_TYPES.DATE,
      key: 'birthDay',
      value: member?.birthDay,
      validation: yup.string(),
    },
    {
      title: svStrings.staff.nationality,
      id: 'member-nationality',
      type: FIELD_TYPES.SELECT,
      options: nationalityOptions,
      optionsText: translatedNationalityOptions,
      key: 'nationality',
      value: member?.nationality,
      validation: yup.string(),
    },
  ] as Field[],
});
